import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { Spinner } from "@zendeskgarden/react-loaders";
import styles from "./index.css";

const LOADING_OVERLAY_DELAY = 1000; // ms

class DelayedComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    const { delay } = this.props;

    this.timeoutId = setTimeout(() => {
      this.setState({ visible: true });
    }, delay);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {
    const { visible } = this.state;
    const { children } = this.props;

    if (!visible) {
      return null;
    }

    return children;
  }
}

DelayedComponent.propTypes = {
  delay: PropTypes.number,
  children: PropTypes.node,
};

function LoadingOverlay({ loading }) {
  if (!loading) {
    return null;
  }

  return (
    <DelayedComponent delay={LOADING_OVERLAY_DELAY}>
      <div className={styles.loadingOverlay}>
        <div className={styles.loaderWrapper}>
          <Spinner delayMS={0} />
        </div>
      </div>
    </DelayedComponent>
  );
}

LoadingOverlay.propTypes = {
  loading: PropTypes.bool,
};

const mapStateToProps = ({
  categories,
  category,
  sections,
  section,
  articles,
}) => {
  return {
    loading:
      categories.isFetching ||
      category.isFetching ||
      sections.isFetching ||
      section.isFetching ||
      articles.isFetching,
  };
};

export default connect(mapStateToProps)(LoadingOverlay);



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js